import { render } from "./IncomingCall.vue?vue&type=template&id=6c21f79a&lang=pug"
import script from "./IncomingCall.vue?vue&type=script&lang=js"
export * from "./IncomingCall.vue?vue&type=script&lang=js"

import "./IncomingCall.vue?vue&type=style&index=0&id=6c21f79a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__